export default {"src":"/_next/static/media/Affordable Neurology Care in Pune.535a7fad.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};